











































import { Component, Mixins, Prop, VModel } from 'vue-property-decorator'

import ConfigField from "../../../../../components/ConfigField/ConfigField.vue";
import ClipboardCopyMixin from "../../../../../logic/helpers/ClipboardCopyMixin";
import {
  successNotificationWrapper,
} from '../../../../../logic/helpers/NotificationService'
import {
  BindTargetByCode,
  BindTargetByCodeRes,
  BindTargetByCodeTypesEnum,
  BindTargetStatus
} from "../../../../types/BindTarget.types";

enum BindState {
  None,
  Loading,
  Check,
}

@Component({
  components: { ConfigField },
  data() {
    return {
      BindState,
    }
  },
})
export default class FeedbackBindGroupId extends Mixins(ClipboardCopyMixin) {
  @VModel({ type: Number, default: null }) feedbackGroupId!: number | null

  @Prop() board!: { title: string, board: string }

  @Prop() bindTargetByCode!: (args: BindTargetByCode) => Promise<BindTargetByCodeRes | void>

  currentStage: BindState = BindState.None

  code: null | string = null

  intervalId: number | null = null

  countdown: number | null = null

  resetFields(): void {
    this.currentStage = BindState.None
    this.code = null
    this.countdown = null

    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
  }

  checkCode(code: string): void {
    this.bindTargetByCode({ type: BindTargetByCodeTypesEnum.Status, code, board_key: this.board.board })
      .then((res) => {
        if (res) {
          const { status } = res

          if (status === BindTargetStatus.Success || status === BindTargetStatus.Expired) {
            if (status === BindTargetStatus.Success) {
              successNotificationWrapper(this.$t('success_alert').toString(), '')
            }

            this.resetFields()
          }
        } else {
          this.resetFields()
        }
      })
  }

  getBindCode(): void {
    this.currentStage = BindState.Loading

    this.bindTargetByCode({ type: BindTargetByCodeTypesEnum.BindFeedback, board_key: this.board.board })
      .then((res) => {
        if (res?.code) {
          const { code } = res
          const oneAndHalfMin = 90000

          this.currentStage = BindState.Check
          this.code = code
          this.countdown = new Date().getTime() + oneAndHalfMin
          this.intervalId = setInterval(() => {
            this.checkCode(code)
          }, 2500)
        } else {
          this.resetFields()
        }
      })
  }

  destroyed() {
    this.resetFields()
  }

  copyCode(): void {
    if (this.code) {
      this.copy(this.code)
    }
  }
}
